import { PermissionService } from "src/app/services/permission.service";
import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { IntegracionToken, IntegracionTokenCreateResponse } from "src/app/models/Integraciones/IntegracionToken";
import { IntegracionesService } from "src/app/services/integraciones.service";
import { TokenStorageService } from "src/app/services/token-storage.service";

@Component({
  selector: "app-mantenedor-integraciones",
  templateUrl: "./mantenedor-integraciones.component.html",
  styleUrls: ["./mantenedor-integraciones.component.scss"],
})
export class MantenedorIntegracionesComponent implements OnInit {
  @ViewChild("createTokenModal") createTokenModal!: TemplateRef<any>;
  loading = false;
  emisorId = "";
  tokens: IntegracionToken[] = [];
  nuevoTokenNombre = "";
  oneTimeToken: IntegracionTokenCreateResponse | null = null;
  actionTokenId = "";

  constructor(
    public permissions: PermissionService,
    private integracionesService: IntegracionesService,
    private tokenService: TokenStorageService,
    private modalService: NgbModal,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.emisorId = this.tokenService.getCompany();
    if (!this.emisorId) {
      return;
    }
    this.loadTokens();
  }

  refreshTokens(): void {
    if (!this.emisorId || this.loading) {
      return;
    }
    this.loadTokens();
  }

  loadTokens(): void {
		if (!(this.permissions.getPermission("86").asignado)) { return; }
    this.loading = true;
    this.integracionesService.getTokens(this.emisorId).subscribe({
      next: (resp) => {
        this.tokens = resp?.data || [];
        this.loading = false;
        this.ref.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.ref.detectChanges();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo cargar la lista de tokens.",
        });
      },
    });
  }

  crearToken(modalRef?: any): void {
		if (!(this.permissions.getPermission("86").asignado && this.permissions.getPermission("86-10").asignado)) { return; }
    if (!this.emisorId || this.loading) {
      return;
    }

    const nombre = this.nuevoTokenNombre.trim();
    if (!nombre) {
      Swal.fire({
        icon: "warning",
        title: "Nombre requerido",
        text: "Debes ingresar un nombre para el token.",
      });
      return;
    }

    this.loading = true;
    this.integracionesService
      .createToken({
        emisorId: this.emisorId,
        nombre,
      })
      .subscribe({
        next: (resp) => {
          const data = resp?.data || null;
          if (data?.tokenInfo) {
            this.upsertToken(data.tokenInfo);
          }
          this.oneTimeToken = data;
          this.nuevoTokenNombre = "";
          this.loading = false;
          this.ref.detectChanges();
          if (modalRef) {
            modalRef.close();
          }
          Swal.fire({
            icon: "success",
            title: "Token generado",
            text: resp?.message || "Token generado correctamente.",
          });
        },
        error: (e) => {
          this.loading = false;
          this.ref.detectChanges();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: e?.error?.message || "No se pudo generar el token.",
          });
        },
      });
  }

  rotateToken(token: IntegracionToken): void {
		if (!(this.permissions.getPermission("86").asignado && this.permissions.getPermission("86-10").asignado)) { return; }
    if (!token?.tokenId || this.loading || !this.isTokenActive(token)) {
      return;
    }

    Swal.fire({
      title: "Generar nuevo token",
      text: "El token actual dejara de ser valido. Asegura guardar el nuevo valor.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Generar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#1BC5BD",
    }).then((result) => {
      if (!result.isConfirmed || !this.permissions.getPermission("86-10").asignado) {
        return;
      }

      this.actionTokenId = token.tokenId;
      this.integracionesService.rotateToken(token.tokenId).subscribe({
        next: (resp) => {
          const data = resp?.data || null;
          if (data?.tokenInfo) {
            this.upsertToken(data.tokenInfo);
          }
          this.oneTimeToken = data;
          this.actionTokenId = "";
          this.ref.detectChanges();
          Swal.fire({
            icon: "success",
            title: "Token renovado",
            text: resp?.message || "Token renovado correctamente.",
          });
        },
        error: (e) => {
          this.actionTokenId = "";
          this.ref.detectChanges();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: e?.error?.message || "No se pudo generar el nuevo token.",
          });
        },
      });
    });
  }

  revokeToken(token: IntegracionToken): void {
		if (!(this.permissions.getPermission("86").asignado && this.permissions.getPermission("86-10").asignado)) { return; }
    if (!token?.tokenId || this.loading || !this.isTokenActive(token)) {
      return;
    }

    Swal.fire({
      title: "Dar de baja token",
      text: "Este token dejara de funcionar inmediatamente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Dar de baja",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#F64E60",
    }).then((result) => {
      if (!result.isConfirmed || !this.permissions.getPermission("86-10").asignado) {
        return;
      }

      this.actionTokenId = token.tokenId;
      this.integracionesService.revokeToken(token.tokenId).subscribe({
        next: (resp) => {
          const updated: IntegracionToken = {
            ...token,
            activo: false,
            fechaRevocacion: new Date().toISOString(),
          };
          this.upsertToken(updated);
          this.actionTokenId = "";
          this.ref.detectChanges();
          Swal.fire({
            icon: "success",
            title: "Token dado de baja",
            text: resp?.message || "Token dado de baja correctamente.",
          });
        },
        error: (e) => {
          this.actionTokenId = "";
          this.ref.detectChanges();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: e?.error?.message || "No se pudo dar de baja el token.",
          });
        },
      });
    });
  }

  dismissToken(): void {
    this.oneTimeToken = null;
  }

  openCreateTokenModal(): void {
		if (!(this.permissions.getPermission("86").asignado && this.permissions.getPermission("86-10").asignado)) { return; }
    this.nuevoTokenNombre = "";
    const modalRef = this.modalService.open(this.createTokenModal, {
      size: "md",
      backdrop: "static",
      keyboard: false,
    });

    modalRef.result.finally(() => {
      this.refreshTokens();
      this.nuevoTokenNombre = "";
    });
  }

  copyToken(value: string): void {
    if (!value) {
      return;
    }

    if (navigator?.clipboard?.writeText) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Copiado",
            text: "Token copiado al portapapeles.",
          });
        })
        .catch(() => this.fallbackCopy(value));
      return;
    }

    this.fallbackCopy(value);
  }

  getMaskedToken(token: IntegracionToken): string {
    if (token?.ultimos4) {
      return `****${token.ultimos4}`;
    }
    return "No disponible";
  }

  getStatusLabel(token: IntegracionToken): string {
    if (!this.isTokenActive(token)) {
      return "Revocado";
    }
    if (this.isTokenExpired(token)) {
      return "Expirado";
    }
    return "Activo";
  }

  getStatusClass(token: IntegracionToken): string {
    if (!this.isTokenActive(token)) {
      return "bg-danger";
    }
    if (this.isTokenExpired(token)) {
      return "bg-warning text-dark";
    }
    return "bg-success";
  }

  getRemainingLabel(token: IntegracionToken): string {
    const expiration = this.getExpirationDate(token);
    if (!expiration) {
      return "Sin fecha";
    }
    if (!this.isTokenActive(token)) {
      return "Sin vigencia";
    }

    const diffMs = expiration.getTime() - new Date().getTime();
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays <= 0) {
      return "Expirado";
    }
    if (diffDays === 1) {
      return "Expira manana";
    }
    return `Quedan ${diffDays} dias`;
  }

  isTokenActive(token: IntegracionToken): boolean {
    return token?.activo !== false && !token?.fechaRevocacion;
  }

  isTokenExpired(token: IntegracionToken): boolean {
    const expiration = this.getExpirationDate(token);
    if (!expiration) {
      return false;
    }
    return expiration.getTime() < new Date().getTime();
  }

  private getExpirationDate(token: IntegracionToken): Date | null {
    if (!token?.fechaExpiracion) {
      return null;
    }
    const date = new Date(token.fechaExpiracion);
    if (Number.isNaN(date.getTime())) {
      return null;
    }
    return date;
  }

  private upsertToken(token: IntegracionToken): void {
    const index = this.tokens.findIndex((item) => item.tokenId === token.tokenId);
    if (index >= 0) {
      this.tokens[index] = token;
      this.tokens = [...this.tokens];
      return;
    }
    this.tokens = [token, ...this.tokens];
  }

  private fallbackCopy(value: string): void {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      const ok = document.execCommand("copy");
      if (ok) {
        Swal.fire({
          icon: "success",
          title: "Copiado",
          text: "Token copiado al portapapeles.",
        });
      } else {
        throw new Error("copy failed");
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "No se pudo copiar",
        text: "Copia el token manualmente.",
      });
    } finally {
      document.body.removeChild(textarea);
    }
  }
}
